module.exports = __webpack_public_path__ + "img/5.b2cc29c6.png";